import React, { useState } from "react";
// Use Forms
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
// React Bootstrap
import { Form, Button, Col, Accordion, Card } from "react-bootstrap";
// // Utils
import { context, workCategories } from "../../../../contexto";

const FormInfoMision = ({ defaultValues, submissionHandler, ...props }) => {
  const [validated] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: defaultValues,
  });

  // On submit del formulario
  const onSubmit = (data) => {
    submissionHandler(data);
  };

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit(onSubmit)} className="m-3">
      <Form.Row>
        <small className="mb-3">
          Los campos con un <b>*</b> deben de ser rellenados.
        </small>
      </Form.Row>
      <Accordion defaultActiveKey="0" className="mb-2">
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="0">
            Información principal
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              <Form.Row>
                <Form.Group as={Col} xs={12} md controlId="name-mission">
                  <Form.Label>{"Nombre de la misión *"}</Form.Label>
                  <Form.Control
                    name="name"
                    placeholder={"Texto"}
                    type="text"
                    isInvalid={errors?.name}
                    {...register("name", {
                      required: "Este campo es obligatorio",
                      maxLength: {
                        value: 80,
                        message: "El máximo de caracteres es 80",
                      },
                    })}
                  />
                  <ErrorMessage errors={errors} name="name" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                </Form.Group>
                <Form.Group as={Col} xs={12} md controlId="key-mission">
                  <Form.Label>{"Clave"}</Form.Label>
                  <Form.Control
                    name="key"
                    placeholder={"Texto"}
                    type="text"
                    isInvalid={errors?.key}
                    {...register("key", {
                      maxLength: {
                        value: 80,
                        message: "El máximo de caracteres es 80",
                      },
                    })}
                  />
                  <ErrorMessage errors={errors} name="key" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                </Form.Group>
              </Form.Row>

              <Form.Row>
                <Form.Group as={Col} xs={12} md controlId="contextId-mission">
                  <Form.Label>{"Contexto"}</Form.Label>
                  <Form.Control name="contextId" as="select" custom isInvalid={errors.contextId} {...register("contextId", { required: "Este campo es obligatorio" })}>
                    {context
                      ? Object.keys(context).map((contextKey, index) => (
                        <option key={index} value={contextKey}>
                          {context[contextKey]}
                        </option>
                      ))
                      : ""}
                  </Form.Control>
                </Form.Group>
                {defaultValues?.category === workCategories[1] && (
                  <Form.Group as={Col} xs={12} md controlId="maxCap-mission">
                    <Form.Label>{"Capacidad"}</Form.Label>
                    <Form.Control name="maxCap" placeholder={"Número"} type="number" isInvalid={errors?.nSister} {...register("maxCap", {})} />
                    <ErrorMessage errors={errors} name="maxCap" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                  </Form.Group>
                )}
              </Form.Row>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>

      <Accordion defaultActiveKey="0" className="mb-2">
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="0">
            Dirección
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              <Form.Row>
                <Form.Group as={Col} xs={12} md controlId="country-mission">
                  <Form.Label>{"País"}</Form.Label>
                  <Form.Control
                    name="country"
                    placeholder={"Texto"}
                    type="text"
                    isInvalid={errors?.country}
                    {...register("country", {
                      maxLength: {
                        value: 60,
                        message: "El máximo de caracteres es 60",
                      },
                    })}
                  />
                  <ErrorMessage errors={errors} name="country" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                </Form.Group>
                <Form.Group as={Col} xs={12} md controlId="provinceAddress-add-new-mission">
                  <Form.Label>{"Provincia-Estado"}</Form.Label>
                  <Form.Control
                    name="provinceAddress"
                    placeholder={"Texto"}
                    type="text"
                    isInvalid={errors?.country}
                    {...register("provinceAddress", {
                      maxLength: {
                        value: 70,
                        message: "El máximo de caracteres es 70",
                      },
                    })}
                  />
                  <ErrorMessage errors={errors} name="provinceAddress" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                </Form.Group>
                <Form.Group as={Col} xs={12} md controlId="postcode-mission">
                  <Form.Label>{"Código postal"}</Form.Label>
                  <Form.Control
                    name="postcode"
                    placeholder={"Texto"}
                    type="text"
                    isInvalid={errors?.postcode}
                    {...register("postcode", {
                      maxLength: {
                        value: 15,
                        message: "El máximo de caracteres es 15",
                      },
                    })}
                  />
                  <ErrorMessage errors={errors} name="postcode" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                </Form.Group>
              </Form.Row>
              <Form.Row>
                <Form.Group as={Col} xs={12} md controlId="place-mission">
                  <Form.Label>{"Localidad"}</Form.Label>
                  <Form.Control
                    name="place"
                    placeholder={"Texto"}
                    type="text"
                    isInvalid={errors?.place}
                    {...register("place", {
                      maxLength: {
                        value: 60,
                        message: "El máximo de caracteres es 60",
                      },
                    })}
                  />
                  <ErrorMessage errors={errors} name="place" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                </Form.Group>

                <Form.Group as={Col} xs={12} md controlId="address-mission">
                  <Form.Label>{"Calle"}</Form.Label>
                  <Form.Control
                    name="address"
                    placeholder={"Texto"}
                    type="text"
                    isInvalid={errors?.address}
                    {...register("address", {
                      maxLength: {
                        value: 150,
                        message: "El máximo de caracteres es 150",
                      },
                    })}
                  />
                  <ErrorMessage errors={errors} name="address" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                </Form.Group>
              </Form.Row>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
      <Accordion defaultActiveKey="0" className="mb-2">
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="0">
            Estado
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              <Form.Row>
                <Form.Group as={Col} xs={12} md controlId="activity-start-mission">
                  <Form.Label>{"Fecha de apertura"}</Form.Label>
                  <Form.Control
                    name="startDate"
                    type="date"
                    isInvalid={errors?.startDate}
                    {...register("startDate", {
                      validate: (date) => {
                        return new Date(date) >= new Date() ? "La fecha no debe ser mayor a hoy" : true;
                      },
                    })}
                  />
                  <ErrorMessage errors={errors} name="startDate" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                </Form.Group>

                <Form.Group as={Col} xs={12} md controlId="activity-end-mission">
                  <Form.Label>{"Fecha de cierre"}</Form.Label>
                  <Form.Control name="endDate" type="date" isInvalid={errors?.endDate} {...register("endDate", {})} />
                  <ErrorMessage errors={errors} name="endDate" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                </Form.Group>
              </Form.Row>
              <Form.Row>
                <Form.Group as={Col} xs={12} md controlId="end-date-mission">
                  <Form.Label>{"Fecha de cesión"}</Form.Label>
                  <Form.Control name="cessionDate" type="date" isInvalid={errors?.activityEnd} {...register("cessionDate", {})} />
                  <ErrorMessage errors={errors} name="cessionDate" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                </Form.Group>
                <Form.Group as={Col} xs={12} md controlId="name-add-new-mission">
                  <Form.Label>{"Entidad cedida"}</Form.Label>
                  <Form.Control
                    name="cessionTo"
                    placeholder={"Texto"}
                    type="text"
                    isInvalid={errors?.cessionTo}
                    {...register("cessionTo", {
                      maxLength: {
                        value: 80,
                        message: "El máximo de caracteres es 80",
                      },
                    })}
                  />
                  <ErrorMessage errors={errors} name="cessionTo" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                </Form.Group>
              </Form.Row>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>

      <Accordion defaultActiveKey="0" className="mb-2">
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="0">
            Calendario actividades
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              <Form.Row>
                <Form.Group as={Col} xs={12} md controlId="start-date-mission">
                  <Form.Label>{"Fecha Inicial"}</Form.Label>
                  <Form.Control name="activityStart" type="date" isInvalid={errors?.activityStart} {...register("activityStart", {})} />
                  <ErrorMessage errors={errors} name="activityStart" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                </Form.Group>

                <Form.Group as={Col} xs={12} md controlId="end-date-mission">
                  <Form.Label>{"Fecha Final"}</Form.Label>
                  <Form.Control name="activityEnd" type="date" isInvalid={errors?.activityEnd} {...register("activityEnd", {})} />
                  <ErrorMessage errors={errors} name="activityEnd" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                </Form.Group>
              </Form.Row>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>

      <Accordion defaultActiveKey="0" className="mb-2">
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="0">
            Datos contacto
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              <Form.Row>
                <Form.Group as={Col} xs={12} md controlId="telephone-mission">
                  <Form.Label>{"Teléfono"}</Form.Label>
                  <Form.Control
                    name="telephone"
                    placeholder={"Teléfono"}
                    type="text"
                    isInvalid={errors?.telephone}
                    {...register("telephone", {
                      maxLength: {
                        value: 25,
                        message: "El máximo de caracteres es 25",
                      },
                    })}
                  />
                  <ErrorMessage errors={errors} name="telephone" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                </Form.Group>

                <Form.Group as={Col} xs={12} md controlId="email-mission">
                  <Form.Label>{"Email"}</Form.Label>
                  <Form.Control
                    name="email"
                    placeholder={"Texto"}
                    type="text"
                    isInvalid={errors?.email}
                    {...register("email", {
                      maxLength: {
                        value: 320,
                        message: "El máximo de caracteres es 320",
                      },
                      pattern: {
                        value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                        message: "El campo debe ser un email",
                      },
                    })}
                  />
                  <ErrorMessage errors={errors} name="email" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                </Form.Group>
              </Form.Row>
              <Form.Row>
                <Form.Group as={Col} xs={12} md controlId="web-mission">
                  <Form.Label>{"Web"}</Form.Label>
                  <Form.Control
                    name="web"
                    placeholder={"Texto"}
                    type="text"
                    isInvalid={errors?.web}
                    {...register("web", {
                      maxLength: {
                        value: 200,
                        message: "El máximo de caracteres es 200",
                      },
                    })}
                  />
                  <ErrorMessage errors={errors} name="web" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                </Form.Group>
                <Form.Group as={Col} xs={12} md controlId="rrss-mission">
                  <Form.Label>{"RRSS"}</Form.Label>
                  <Form.Control
                    name="RRSS"
                    placeholder={"Texto"}
                    type="text"
                    as={"textArea"}
                    isInvalid={errors?.RRSS}
                    {...register("RRSS", {
                      maxLength: {
                        value: 100,
                        message: "El máximo de caracteres es 100",
                      },
                    })}
                  />
                  <ErrorMessage errors={errors} name="RRSS" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                </Form.Group>
              </Form.Row>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
      {defaultValues.isCollaborative && defaultValues.type === "Obra" ? (
        <Accordion defaultActiveKey="0" className="mb-2">
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="0">
              Personal
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="0">
              <Card.Body>
                <Form.Row>
                  <Form.Group as={Col} xs={12} md controlId="nSisterCollaborative-mission">
                    <Form.Label>{"Número de hermanas que trabajan en la obra"}</Form.Label>
                    <Form.Control name="nSisterCollaborative" placeholder={"Número"} type="number" isInvalid={errors?.nSister} {...register("nSisterCollaborative", {})} />
                    <ErrorMessage errors={errors} name="nSisterCollaborative" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                  </Form.Group>

                  <Form.Group as={Col} xs={12} md controlId="peopleAttendedCollaborative-mission">
                    <Form.Label>{"Población Atendida"}</Form.Label>
                    <Form.Control name="peopleAttendedCollaborative" placeholder={"Número"} type="number" isInvalid={errors?.nSister} {...register("peopleAttendedCollaborative", {})} />
                    <ErrorMessage errors={errors} name="peopleAttendedCollaborative" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                  </Form.Group>
                </Form.Row>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      ) : (
        <Accordion defaultActiveKey="0" className="mb-2">
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="0">
              Personal
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="0">
              <Card.Body>
                <Form.Row>
                  <Form.Group as={Col} xs={12} md controlId="nSisterCollaborative-mission">
                    <Form.Label>{"Número de hermanas que trabajan en la obra"}</Form.Label>
                    <Form.Control name="nSisterCollaborative" placeholder={"Número"} type="number" isInvalid={errors?.nSister} {...register("nSisterCollaborative", {})} />
                    <ErrorMessage errors={errors} name="nSisterCollaborative" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                  </Form.Group>
                </Form.Row>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      )}

      <Form.Group>
        <Button type="submit" variant="outline-primary" className="btn btn-block mt-5">
          Guardar
        </Button>
      </Form.Group>
    </Form>
  );
};

export default FormInfoMision;
